const setQuestionWithId = (question, loopIndex) => {
    const _question = JSON.parse(JSON.stringify(question));
    _question.id = loopIndex && loopIndex > 0 ? _question.id + '-' + loopIndex : question.id;
    return _question;
}

export default setQuestionWithId;